import { memo, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Stack,
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Chip,
  Typography,
  Alert,
} from "@mui/material";

const Vtex = ({ ecommerce, warehouses, onSave, loading, isEdit }) => {
  const [formData, setFormData] = useState(ecommerce);
  const [deliveryInput, setDeliveryInput] = useState("");

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      configuration: {
        ...prev.configuration,
        authentication: {
          ...prev.configuration.authentication,
          [field]: value,
        },
      },
    }));
  };

  const handleWarehouseChange = (e) => {
    setFormData({ ...formData, warehouse: e.target.value });
  };

  const addDeliveryMethod = () => {
    if (!deliveryInput) return;
    const currentMethods =
      formData.configuration.options.enabled_delivery_methods || [];
    if (!currentMethods.includes(deliveryInput)) {
      setFormData((prev) => ({
        ...prev,
        configuration: {
          ...prev.configuration,
          options: {
            ...prev.configuration.options,
            enabled_delivery_methods: [...currentMethods, deliveryInput],
          },
        },
      }));
    }
    setDeliveryInput("");
  };

  const removeDeliveryMethod = (method) => {
    const currentMethods =
      formData.configuration.options.enabled_delivery_methods.filter(
        (m) => m !== method,
      );
    setFormData((prev) => ({
      ...prev,
      configuration: {
        ...prev.configuration,
        options: {
          ...prev.configuration.options,
          enabled_delivery_methods: currentMethods,
        },
      },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <form>
      <h3 style={{ marginBottom: "20px" }}>Configuración Vtex</h3>

      <Alert severity="info" sx={{ mb: 3 }}>
        Ingresa las credenciales de tu aplicación Vtex (App Key y App Token)
        para sincronizar los pedidos.
      </Alert>

      <FormControl fullWidth sx={{ mb: 3 }}>
        <InputLabel>Bodega Asociada</InputLabel>
        <Select
          value={formData.warehouse || ""}
          label="Bodega Asociada"
          onChange={handleWarehouseChange}
        >
          {warehouses.map((w) => (
            <MenuItem key={w.id} value={w.id}>
              {w.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: "bold" }}>
            Credenciales API
          </Typography>
          <TextField
            fullWidth
            label="Nombre de la tienda (Account Name)"
            placeholder="Ej: mitiendavtex"
            helperText="El nombre de tu cuenta tal como aparece en la URL (ej: {nombre}.myvtex.com)"
            value={formData.configuration.authentication.shop_name || ""}
            onChange={(e) => handleChange("shop_name", e.target.value)}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="App Key"
            placeholder="vtexappkey-..."
            value={formData.configuration.authentication.app_key || ""}
            onChange={(e) => handleChange("app_key", e.target.value)}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="App Token"
            placeholder="App Token"
            value={formData.configuration.authentication.app_token || ""}
            onChange={(e) => handleChange("app_token", e.target.value)}
          />
        </Grid>
      </Grid>

      <Box
        sx={{
          mt: 4,
          mb: 3,
          border: "1px solid #e0e0e0",
          p: 2,
          borderRadius: 2,
        }}
      >
        <InputLabel sx={{ mb: 1 }}>Métodos de Envío Habilitados</InputLabel>
        <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
          <TextField
            size="small"
            placeholder="Ej: Starken, Chilexpress..."
            value={deliveryInput}
            onChange={(e) => setDeliveryInput(e.target.value)}
            fullWidth
          />
          <Button
            variant="contained"
            onClick={addDeliveryMethod}
            disabled={!deliveryInput}
            sx={{ marginTop: "30px !important" }}
          >
            Agregar
          </Button>
        </Stack>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {formData.configuration.options.enabled_delivery_methods?.length >
          0 ? (
            formData.configuration.options.enabled_delivery_methods.map((m) => (
              <Chip
                key={m}
                label={m}
                onDelete={() => removeDeliveryMethod(m)}
                color="primary"
                variant="outlined"
              />
            ))
          ) : (
            <span style={{ color: "#999", fontSize: "0.9rem" }}>
              No hay métodos configurados
            </span>
          )}
        </Stack>
      </Box>

      <Button
        type="submit"
        variant="contained"
        fullWidth
        disabled={loading}
        size="large"
        onClick={handleSubmit}
      >
        {isEdit ? "Actualizar Integración" : "Agregar Integración"}
      </Button>
    </form>
  );
};

export default memo(Vtex);
